<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isAddNewUserSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @change="(val) => $emit('update:is-add-new-user-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <b-card>
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Tambah Pengumuman
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <b-form class="mt-2">
      <b-row>
        <b-col sm="12">
          <b-form-group
            label="Judul"
            label-for="judul"
          >
            <b-form-input
              v-model="userData.judul"
              name="judul"
              placeholder="judul"
            />
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group
            label="Pengumuman"
            label-for="pengumuman"
          >
          <quill-editor
            id="pengumuman"
            v-model="userData.pengumuman"
            :options="{
              modules: {
                toolbar: [
                  ['bold', 'italic', 'underline', 'strike'],
                  [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                  [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                  [{ 'color': [] }, { 'background': [] }],
                  [{ 'align': [] }],
                  ['clean'],
                  ['link']
                ]
              }
            }"
          />
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group
            label="Link"
            label-for="link"
          >
            <b-form-input
              v-model="userData.link"
              name="link"
              placeholder="link"
            />
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group
            label="Gambar"
            label-for="gambar"
          >
          <b-media no-body  class="mb-2">
              <b-media-aside>
                <b-link>
                  <b-img
                    ref="previewEl"
                    rounded
                    :src="foto"
                    height="80"
                    :key="reloadImg"
                  />
                </b-link>
                <!--/ avatar -->
              </b-media-aside>

              <b-media-body class="mt-75 ml-75">
                <!-- upload button -->
                <b-button
                  variant="primary"
                  size="sm"
                  class="mb-75 mr-75"
                  @click="$refs.refInputEl.$el.click()"
                >
                  Unggah Gambar
                </b-button>
                <b-form-file
                  ref="refInputEl"
                  v-model="filePhoto"
                  accept=".jpg, .png, .gif"
                  :hidden="true"
                  plain
                  @change="onFileSelected"
                />
                <!--/ upload button -->

                <!-- reset -->
                <b-button
                  variant="outline-secondary"
                  size="sm"
                  class="mb-75 mr-75"
                  @click="resetGambar"
                >
                  Reset
                </b-button>
                <!--/ reset -->
                <div>tipe file yang diperbolehkan JPG, GIF atau PNG, ukuran 200px x 200px dan besar file maksimal 5MB</div>
              </b-media-body>
            </b-media>
        </b-form-group>
        </b-col>


        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-2 mr-1"
            @click="simpanData"
          >
            Simpan
          </b-button>
        </b-col>
      </b-row>
    </b-form>
      </b-card>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BRow, BCol,BCard,BFormTextarea,BFormFile,BLink,BMedia,BMediaAside,BImg,BMediaBody,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required, alphaNum, email } from '@validations'
extend('required', {
    ...required,
    message: 'Bagian ini wajib diisi',
});
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import countries from '@/connection-api/data/other/countries'
import store from '@/store'
import { quillEditor } from 'vue-quill-editor'

// quill editor styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import '@core/scss/vue/libs/vue-flatpicker.scss'
import {
  uploadFoto,
  downloadPhoto,
} from '@/connection-api/lembarkehidupan'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BCard,
    BFormTextarea,
    BFormFile,
    BLink,
    BMedia,
    BMediaAside,
    BImg,
    BMediaBody,
    quillEditor,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-new-user-sidebar-active',
  },
  props: {
    isAddNewUserSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      filePhoto: null,
      reloadImg: 0,
      foto: null,
      userData: {},
      required,
      alphaNum,
      email,
      countries,
      configs: {
        basic: {},
        wrap: {
          wrap: true,
          altFormat: 'M j, Y',
          altInput: true,
          dateFormat: 'Y-m-d',
        },
      },
      proyekOptions: {
        selected: 'id',
        options: [
          { value: null, label: 'Semua' },
        ],
      },
    }
  },
  methods: {
    resetGambar() {
      this.foto = null
      this.filePhoto = null
    },
    renderImage() {
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        this.foto = reader.result;
        this.reloadImg += 1
      });
      reader.readAsDataURL(this.foto);
    },
    onFileSelected(event) {
      this.foto = event.target.files[0];
      this.filePhoto = event.target.files[0];
      this.renderImage();
    },
    simpanData() {
      if (this.filePhoto != null) {
          var metadata = { }
          uploadFoto(this.filePhoto, metadata, event => {
            this.progress = Math.round((100 * event.loaded) / event.total)
          })
            .then(response1 => {
              if (response1.data.status.code === '00') {
                this.userData.gambar = response1.data.data.filename;
                store.dispatch('pengumuman-crud/addData', this.userData)
                  .then(response => {
                    if (response.data.success === true) {
                      this.makeToast('success', 'Data berhasil disimpan.')
                      this.$emit('refetchData')
                      this.userData.nama = null
                    } else {
                      this.makeToast('danger', response.data.message)
                    }
                  })
                  .catch(error => {
                  })
              }
            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Pengumuman',
                  icon: 'EditIcon',
                  variant: 'danger',
                  text: error,
                },
                duration: 5000,
              })
            });
        } else {
          store.dispatch('pengumuman-crud/addData', this.userData)
            .then(response => {
              if (response.data.success === true) {
                this.makeToast('success', 'Data berhasil disimpan.')
                this.$emit('refetchData')
                this.userData.nama = null
              } else {
                this.makeToast('danger', response.data.message)
              }
            })
            .catch(error => {
            })
        }
        
    },
    makeToast(variant = null, message = null, title = null) {
      this.$bvToast.toast(message, {
        title: 'Prodi',
        variant,
        solid: true,
        autoHideDelay: 3000,
        enableHtml: true,
        allowHtml: true,
      })
    },
    mappingSelectOption(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.id,
          })
        })
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
